<ng-container [formGroup]="form">

  <div class="row mb-3">
    <selectfield
      [form]="form"
      [fieldName]="provinciaName"
      fieldLabel="Provincia"
      [items]="itemsProvince$ | async"
      selectedString="Seleziona una provincia">
    </selectfield>
  </div>
  
  <div class="row mb-3">
    <selectfield
      [form]="form"
      [fieldName]="comuneName"
      fieldLabel="Comune"
      [items]="itemsComuni$ | async"
      selectedString="Seleziona un comune">
    </selectfield>
  </div>

</ng-container>
